import { Feature } from 'ol';
import Map from 'ol/Map.js';
import { unByKey } from 'ol/Observable.js';
import PointerInteraction from 'ol/interaction/Pointer';
import Overlay from 'ol/Overlay.js';
import { getArea, getLength, offset } from 'ol/sphere.js';
import { LineString, Polygon, Geometry } from 'ol/geom.js';
// import Draw, { DrawEvent } from 'ol/interaction/Draw.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import MapBrowserEvent from 'ol/MapBrowserEvent';
import { EventsKey } from 'ol/events';
import { ObjectEvent } from 'ol/Object';
import Event from 'ol/events/Event';
import GeometryType from 'ol/geom/GeometryType';
import OverlayPositioning from 'ol/OverlayPositioning';
import { BaseEngine, WGisToolOption } from './wgis.utils';
import { WGisBaseTool } from './wgis.tool';
import { WGisTooltip, WgisTooltipOption } from './wgis.ui.tooltip';
import { THIS_EXPR, ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { AppStatus, GisQureyResult } from '../core/models';
import WKT from 'ol/format/WKT';
import { getVectorContext } from 'ol/render';
import RenderEvent from 'ol/render/Event';
import { easeOut } from 'ol/easing';
import { WGisFeature } from './wgis.feature';
import { Extent } from 'ol/extent';
import { WGisVectorEngine } from './wgis.vectorengine';
import { WGisEngine } from './wgis.engine';
/**
 * tool per estrazione di informazione lavora in due modalità quand la mappa ha una risolozione/scala maggiore di atresolution,
 * e quando è esplicitamente attivato al click
 * come gestore di click è attivabile e disattivabile dalla toolbar
 * come gestore dellevento puntattore fermo è attivato dalla modifica della risoluzione
 */

export class WGisToolInfo extends WGisBaseTool {
  map: Map;
  sketch: Feature;
  infoTooltip: WGisTooltip;
  pointerlistener: EventsKey;
  clicklistener: EventsKey;
  postrenderlistenerKey: EventsKey | EventsKey[];

  pixel: number[];
  pixelTollerance: number;
  timeTollerance: number;
  hidable: boolean;
  hideTimeoutId: any;
  hideTimeoutEllapsed = 8000;
  checkTimeoutId: any;
  resolutionThreshold: number;
  showelapsed: number;

  constructor(protected opt: WGisToolOption, pixelTollerance: number, timeTollerance: number) {
    super(opt);
    this.pointerlistener = null;
    this.clicklistener = null;
    this.resolutionThreshold = 100;
    this.opt.icon = this.opt.icon ? this.opt.icon : 'fa-info-circle';
    this.opt.icon = 'fa-info-circle';
    this.opt.wgisservice.pMap.then((map: Map) => {
      this.map = map;
    });
    this.hidable = true;
    this.pixelTollerance = pixelTollerance;
    this.timeTollerance = timeTollerance;
    this.opt.wgisservice.pMap.then((map) => {
      this.createInfoTooltip();
      this.activateSingleClickHandler();
      // map.getView().on('change:resolution', (event: ObjectEvent) => {
      //   const resolution: number = event.target.getResolution();
      //   // console.log(`resolution : ${resolution}`);
      //   if (resolution < this.resolutionThreshold) {
      //     this.activateSingleClickHandler();
      //   } else {
      //     this.deactivateSingleClickHandler();
      //   }
      //   return false;
      // });
    });
  }

  private deactivateSingleClickHandler() {
    if (this.pointerlistener) {
      unByKey(this.pointerlistener);
      this.pointerlistener = null;
    }
  }

  private activateSingleClickHandler() {
    if (this.pointerlistener == null) {
      this.pointerlistener = this.map.on('singleclick', (evt: MapBrowserEvent) => { this.pointerMoveHandler(evt); return false; });
    }
  }


  createInfoTooltip() {
    if (this.infoTooltip === undefined) {

      this.infoTooltip = new WGisTooltip({
        wgisservice: this.opt.wgisservice,
        initial: 'tooltip-info hidden',
        offset: [15, 0],
        translation: '',
        positioning: OverlayPositioning.CENTER_LEFT,
        autoPan: true,
      });

      this.infoTooltip.notStatic();
      // this.infoTooltip.myTooltip.panIntoView();
      this.hidable = true;
      this.infoTooltip.element.then((el) => {
        el.onmouseenter = () => {
          // console.log('mouse enter >>>>>>>>>>>>>>>>>>>>>>>')
          this.hidable = false;
          if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
          }
          this.infoTooltip.show();
        };
        el.onmouseleave = () => {
          // console.log('mouse leave <<<<<<<<<<<<<<<<<<<<<<<<<<')
          this.hidable = true;
          if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
          }
          this.hideTimeoutId = setTimeout(() => { this.hideInfo(); }, this.hideTimeoutEllapsed);
        };
        // el.onmouseout = () => {
        //   console.log('mouse out   <<<<<<<<<<<<<<<<<<<<<<<<<<')
        //   this.hidable = true;
        //   if (this.hideTimeoutId) {
        //     clearTimeout(this.hideTimeoutId);
        //   }
        //   this.hideTimeoutId = setTimeout(() => { this.hideInfo(); }, 2000);
        // };
      });
    }
  }

  hideInfo() {
    if (this.hidable) {
      // console.log('hidable --------------------------------------');
      this.infoTooltip.hide();
      this.infoTooltip.setPosition(undefined);
    } else {
    }
  }

  closeInfo(){
    clearTimeout(this.hideTimeoutId);
    this.infoTooltip.hide();
    this.infoTooltip.setPosition(undefined);
  }

  activate() {
    this.opt.wgisservice.pMap.then((map: Map) => {
      this.trigger();
    });
  }

  deactivate() {
    this.stop();
  }

  stop() {
    // todo dispose all not calling drawend!
    if (this.isActive()) {
      super.deactivate();
    }
    if (this.clicklistener !== null) {
      unByKey(this.clicklistener);
      this.clicklistener = null;
    }
    // if (this.infoTooltip) {
    //   this.infoTooltip.hide();
    // }
    // this.hidable = true;
    // this.hideInfo();
  }

  //  Handle pointer move.
  private clickHandler(evt: MapBrowserEvent): void {
    if (evt.dragging) {
      return;
    }
    let left = evt.pixel[0];
    let top = evt.pixel[1];
    this.pixel = evt.pixel;
    this.stopHideToolTip();
    this.getInfo(true);

  }

  private startHideToolTip() {
    if (this.hideTimeoutId) {
      clearTimeout(this.hideTimeoutId);
    }
    this.hideTimeoutId = setTimeout(() => { this.hideInfo(); }, this.hideTimeoutEllapsed);
  }

  private stopHideToolTip() {
    if (this.hideTimeoutId) {
      clearTimeout(this.hideTimeoutId);
    }
  }

  //  Handle pointer move.
  private pointerMoveHandler(evt: MapBrowserEvent): void {
    if (evt.dragging) {
      return;
    }
    let left = evt.pixel[0];
    let top = evt.pixel[1];
    this.pixel = evt.pixel;
    // this.startHideToolTip();
    if (this.checkTimeoutId) {
      clearTimeout(this.checkTimeoutId);
    }
    this.checkTimeoutId = setTimeout(() => {
      this.checkPause(left, top);
    }, this.timeTollerance);
  }

  private checkPause(left: number, top: number) {
    const mandist = Math.abs(this.pixel[0] - left) + Math.abs(this.pixel[1] - top);
    if (this.hidable && (mandist < this.pixelTollerance)) {
      // console.log('dist is ' + mandist + '-----------------------')
      this.hideInfo();
      this.getInfo(false);
    }
  }
  // chiama ws per avere info e le visualizzo nell tooltip
  getInfo(click: boolean): void {
    const status: AppStatus = this.opt.wgisservice.getAppStatus();
    const coordinate = this.map.getCoordinateFromPixel(this.pixel);
    const pixelsoffset = this.map.getView().getResolution() * 15;
    if (this.opt.wgisservice.getConnectionStatus()) {
      this.opt.wgisservice.getWmaiApiService().queryGisByExtent(
        (coordinate[0] - pixelsoffset),
        (coordinate[1] - pixelsoffset),
        (coordinate[0] + pixelsoffset),
        (coordinate[1] + pixelsoffset),
        localStorage.getItem('locale') || 'it'
      ).subscribe((result: GisQureyResult[]) => {
        if (result.length > 0) {
          const format = new WKT();
          // console.log(`Found ${result.length} results`)
          this.infoTooltip.text('');
          this.infoTooltip.setPosition(coordinate);
          let div_content = document.createElement('div');
          div_content.setAttribute('class', 'ui middle aligned divided list tooltip-info-content')
          this.addCloseButton(div_content);
          for (let i = 0, j = result.length; i < j; i++) {
            const res = result[i];
            this.addItemToList(res, div_content, status);
          }
          this.hidable = true;
          this.infoTooltip.show();
          this.startHideToolTip();
        }
      });
    } else {
      const selsource = this.opt.wgisservice.getSelectionSource();
      const extent: [number, number, number, number] = [
        coordinate[0] - pixelsoffset,
        coordinate[1] - pixelsoffset,
        coordinate[0] + pixelsoffset,
        coordinate[1] + pixelsoffset,
      ];

      // console.log(`Found ${result.length} results`)
      this.infoTooltip.text('');
      this.infoTooltip.setPosition(coordinate);
      let div_content = document.createElement('div');
      div_content.setAttribute('class', 'ui middle aligned divided list tooltip-info-content')
      this.infoTooltip.appendElement(div_content);
      this.addCloseButton(div_content);
      selsource.forEachFeatureInExtent(<Extent>extent, (fea: WGisFeature) => {
        // console.log(fea);
        // console.log(fea.get('id'));
        var res: GisQureyResult = new GisQureyResult();
        res.geom = fea.get('geom');
        res.titolo = fea.get('titolo');
        res.id = fea.get('id');
        res.tipo = 'ost'
        this.addItemToList(res, div_content, status);
      });
      this.hidable = true;
      this.infoTooltip.show();
      this.startHideToolTip();
    }
    // console.log('GETINFO ' + ',x ' + (coordinate[0] - pixelsoffset) + ',y ' + (coordinate[1] - pixelsoffset) + ',x ' + (coordinate[0] + pixelsoffset) + ',y ' + (coordinate[1] + pixelsoffset));
  }

  addCloseButton(div_content: HTMLDivElement){
    let div = document.createElement('div');
    div.setAttribute('class', 'wgis-close-tooltip')
    let button = document.createElement('button')
    button.setAttribute('class', 'ui icon red button')
    let icon = document.createElement('i');
    icon.setAttribute('class', 'close icon');
    button.append(icon)
    button.onclick = (_evt) => { this.closeInfo()};
    div.append(button)
    this.infoTooltip.appendElement(div);
    this.infoTooltip.appendElement(div_content);
  }

  addItemToList(res: GisQureyResult, div_content: HTMLDivElement, status: AppStatus){
    let item = document.createElement('div');
    item.setAttribute('class', 'item');
    let content = document.createElement('div');
    content.setAttribute('class', 'item');
    content.innerHTML = `<b>${res.tipo}</b>: ${res.titolo}`;
    let rigth_content = document.createElement('div');
    rigth_content.setAttribute('class', 'right floated content');
    let button = document.createElement('button')
    let icon = document.createElement('i');
    
    if(status == AppStatus.EditExp && res.tipo == 'ost'){
      button = document.createElement('button')
      button.setAttribute('class', 'ui icon button')
      icon = document.createElement('i');
      icon.setAttribute('class', 'calendar plus outline icon');
      icon.setAttribute('title', 'use');
      icon.onclick = (_evt) => { this.useResult(res); };
      button.append(icon);
      rigth_content.append(button);
    }

    button = document.createElement('button')
    button.setAttribute('class', 'ui icon button')
    icon = document.createElement('i');
    icon.setAttribute('class', 'info circle icon');
    icon.setAttribute('title', 'detail');
    icon.onclick = (_evt) => { this.navigateResult(res); };
    button.append(icon);
    rigth_content.append(button);

    button = document.createElement('button')
    button.setAttribute('class', 'ui icon button')
    icon = document.createElement('i');
    icon.setAttribute('class', 'eye icon');
    icon.setAttribute('title', 'show');
    icon.onclick = (_evt) => { this.animateResult(res); };
    button.append(icon);
    rigth_content.append(button);

    item.append(rigth_content)
    item.append(content)
    div_content.append(item);
  }


  navigateResult(res: GisQureyResult) {
    this.opt.wgisservice.redirectToInfo(res);
  }
  useResult(res: GisQureyResult) {
    // console.log("Sono in wgis.tool e richiamo wgis.service");
    // console.log(res);
    this.opt.wgisservice.sendNewOst(res);
  }
  animateResult(res: GisQureyResult) {
    // console.log(`over res ${res.tipo} ${res.id} ${res.titolo}`);

    const duration = 2000;
    const format = new WKT();
    const geom: Geometry = format.readGeometry(res.geom);
    const start = new Date().getTime();
    const onEngine = this.opt.wgisservice.engines.find((engine) => engine['mapName'] == 'WMAI WMS'); // getOnEngine();
    const listenerKey: EventsKey | EventsKey[] = onEngine.getLayer().on('postrender', (evt: RenderEvent) => {
      const vectorContext = getVectorContext(evt);
      const frameState = evt.frameState;
      const flashGeom = geom;
      const elapsed = frameState.time - start;
      const elapsedRatio = elapsed / duration;
      // radius will be 5 at start and 30 at end.
      const radius = easeOut(elapsedRatio) * 20;
      const opacity = easeOut(1 - elapsedRatio) * 0.5;
      // opacity = opacity * opacity;
      // console.log(`radius ${radius} opacity ${opacity}`);
      const style = new Style({
        stroke: new Stroke({
          color: 'rgba(255, 0, 0, ' + opacity + ')',
          width: radius,
        }),
        image: new CircleStyle({
          radius: radius * 2,
          fill: new Fill({ color: 'rgba(255, 0, 0, ' + opacity + ')' }),
          stroke: new Stroke({
            color: 'rgba(255, 0, 0, ' + opacity + ')',
            width: 0.25 + opacity
          })
        })
      });

      vectorContext.setStyle(style);
      vectorContext.drawGeometry(flashGeom);
      if (elapsed > duration) {
        unByKey(listenerKey);
        return;
      }
      // tell OpenLayers to continue postrender animation
      this.map.render();
    });
    this.map.render();
  }

  trigger() {
    super.activate();
    this.createInfoTooltip();
    this.map.on('singleclick', (evt: MapBrowserEvent) => { this.clickHandler(evt); });
    // this.map.getViewport().addEventListener('mouseout', () => { this.hideInfo(); });
    // console.log('INFO ACTIVE---------------------');
  }
}

